import React from "react";
import "../../global.scss";
import { connect } from "react-redux";
import { phoneAuth } from "../../Store/Actions";
import LoginComponents from "../Login/LoginComponents";
import { getPlatforms } from "@ionic/react";


const Login: React.FC = (props: any) => {
  React.useEffect(() => {
    
    if (props.result && props.result.verificationId) {
      props.history.push("/otp");
    }
  }, [props.result]);
  return <LoginComponents {...props} />;
};


export default connect(
  ({ auth: { result, mobileNumber } }: any) => {
    return { result, mobileNumber };
  },
  { phoneAuth },
)(Login);
